import { render, staticRenderFns } from "./busOrder1.vue?vue&type=template&id=324ec631&scoped=true&"
import script from "./busOrder1.vue?vue&type=script&lang=js&"
export * from "./busOrder1.vue?vue&type=script&lang=js&"
import style0 from "./busOrder1.vue?vue&type=style&index=0&id=324ec631&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ec631",
  null
  
)

export default component.exports